import {
  ADD_FORM_ERROR,
  REMOVE_FORM_ERROR,
  FORM_ERROR_SCROLL_TOP_OFF
} from './constants';

export const addFormError = (formError) => ({
  type: ADD_FORM_ERROR,
  payload: formError
});

export const removeFormError = () => ({
  type: REMOVE_FORM_ERROR
});

export const setScrollTopOff = () => ({
  type: FORM_ERROR_SCROLL_TOP_OFF
});
